import type { InventoryState } from "@/domains/inventory/slice";
import { ownerTypePriority } from "@/domains/inventory/helpers/ownerTypePriority";

export const sortInventories = (inventoryMap: InventoryState["inventoryMap"]) =>
  Object.entries(inventoryMap).sort(([, a], [, b]) => {
    const getPriority = (type: string) => ownerTypePriority[type] ?? Infinity;
    return getPriority(a.ownerType) - getPriority(b.ownerType);
  });
